export default __webpack_public_path__ + "62a6af1e7f879b9f53d19e7fc7f5f18d.png";